module.exports = __webpack_public_path__ + "img/txt2.ac693ef3.png";